import React from "react";
import { Box, Paper, Avatar, Typography, Skeleton } from "@mui/material";

const StatCard = ({ icon, label, value, color, loading: isLoading }) => (
    <Paper
        elevation={0}
        sx={{
            p: 2.5,
            borderRadius: 3,
            border: `1px solid ${color}20`,
            background: `linear-gradient(135deg, ${color}08 0%, ${color}03 100%)`,
            transition: "all 0.25s ease",
            "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: `0 8px 25px ${color}15`,
                borderColor: `${color}40`,
            },
        }}
    >
        <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar sx={{ bgcolor: `${color}15`, color, width: 40, height: 40 }}>
                {icon}
            </Avatar>
            <Box>
                {isLoading ? (
                    <Skeleton variant="text" width={60} height={36} />
                ) : (
                    <Typography variant="h5" fontWeight={700} color={color} fontFamily="Montserrat, sans-serif">
                        {value ?? "–"}
                    </Typography>
                )}
                <Typography variant="caption" color="text.secondary" fontWeight={500}>
                    {label}
                </Typography>
            </Box>
        </Box>
    </Paper>
);

export default StatCard;
